import { AxiosRequestConfig } from 'axios';
import { getSessionToken } from '@/shared/infrastructure/adapters/storage';

export const requestInterceptor = (request: AxiosRequestConfig): AxiosRequestConfig => {
  if (request.headers) {
    request.headers.Authorization = `Bearer ${getSessionToken()}`;
  }

  return request;
};
